import {Component, Injector} from "@angular/core";
import {ProductSpecialSearchModel} from "../product-special-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-product-special-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(ProductSpecialSearchModel),
        registerSearchControl(ProductSpecialMultiSelectSearchControlComponent)
    ]
})
export class ProductSpecialMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<ProductSpecialSearchModel> {
    constructor(model: ProductSpecialSearchModel, injector: Injector) {
        super(model, injector, "sellableId", "name");
    }
}
